import { db, withSyncWrite } from '../db/indexeddb'

/**
 * **Ein Projekt geht in einem gleichnamigen auf** (Namens-Deduplizierung, ADR 0001): Alles, was auf
 * `fromId` zeigt, zeigt danach auf `toId` — Aufgaben, Abschnitte, Pinnwand-Elemente,
 * Projekt-Kommentare und Unterprojekte. Aufgaben und Unterprojekte übernehmen dazu den Lebensbereich
 * des Ziels.
 *
 * Ohne Buchführung: `fromId` war nie hochgeladen, also auch nichts, was darauf zeigt — die Kinder
 * warten noch mit ihrem `create` (auf die Cloud-Kennung ihres Elternteils) und nehmen den neuen Bezug
 * dann mit.
 */
export async function remapMergedProject(fromId: string, toId: string): Promise<void> {
  const lifeSpace = (await db.projects.get(toId))?.lifeSpace
  const follow = lifeSpace ? { lifeSpace } : {}
  await withSyncWrite(async () => {
    await db.tasks.filter(t => t.projectId === fromId).modify({ projectId: toId, ...follow })
    await db.sections.filter(s => s.projectId === fromId).modify({ projectId: toId })
    await db.canvasNotes.filter(n => n.projectId === fromId).modify({ projectId: toId })
    await db.projectComments.filter(c => c.projectId === fromId).modify({ projectId: toId })
    await db.projects.filter(p => p.parentId === fromId).modify({ parentId: toId, ...follow })
  })
}
